/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/button-has-type */
import React from 'react';
import { actionIcons } from '../../configs/Icons';
import { DeleteIcon, EditIcon, LoadingAnimateIcon } from './SVGIcon';
import cn from './cn';

const btnCmnStyle =
    'capitalize text-white text-xs md:text-sm font-medium py-px md:py-2 px-2 md:px-3 rounded md:rounded-lg h-6 md:h-10 min-w-[40px] md:min-w-[80px] disabled:bg-primary-100 disabled:text-primary-700 disabled:cursor-default disabled:select-none disabled:pointer-event-none focus:outline-none ';

const btnLCmnStyle =
    'capitalize text-primary hover:text-white transition text-sm font-medium py-2 px-3 border rounded-lg min-w-[80px]';

// Button Primary with Animate
export function ButtonPrimary({
    title,
    onClick,
    disabled,
    loading = false,
    className = '',
    btnType = 'button'
}) {
    return (
        <button
            type={btnType || 'button'}
            onClick={onClick}
            className={cn(`relative bg-secondary overflow-hidden`, btnCmnStyle, className, {
                'pointer-events-none': loading
            })}
            disabled={disabled}
        >
            {loading && (
                <span className="absolute h-full w-full top-0 left-0 transform-x-1/2 ">
                    <LoadingAnimateIcon />
                </span>
            )}
            <span
                className={cn({
                    invisible: loading
                })}
            >
                {title}
            </span>
        </button>
    );
}

// Button Confirm
export function ButtonConfirm({
    children,
    title,
    onClick,
    disabled,
    className = '',
    btnType = 'button',
    loading = false
}) {
    return (
        <button
            type={btnType}
            onClick={onClick}
            className={`bg-error relative ${btnCmnStyle} ${className} ${
                loading ? 'pointer-events-none' : ''
            }`}
            disabled={disabled}
        >
            {loading && (
                <span
                    className={`inline-block h-full w-full top-0 right-0 absolute bg-error ${btnCmnStyle}`}
                >
                    <LoadingAnimateIcon />
                </span>
            )}
            {children || title}
        </button>
    );
}

// -- Option Button
export function OptionButton({
    onClick,
    width = 'w-8',
    height = 'h-8',
    rotate = false,
    disabled = false
}) {
    return (
        <span>
            <button
                type="button"
                disabled={disabled}
                onClick={(e) => onClick(e)}
                className={`group/option relative transition-opacity duration-300 ml-1 disabled:grayscale-[0.5] disabled:pointer-events-none disabled:cursor-default disabled:select-none gar ${width} ${height}`}
            >
                <img
                    src={actionIcons.optionBtnWL}
                    alt="Option Icon Line"
                    className={`group-hover/option:opacity-0 opacity-100 absolute top-0 left-0 w-full ${
                        rotate ? 'rotate-90' : 'rotate-0'
                    }`}
                />
                <img
                    src={actionIcons.optionBtnWF}
                    alt="Option Icon Fill"
                    className={`group-hover/option:opacity-100 opacity-0 absolute top-0 left-0 w-full ${
                        rotate ? 'rotate-90' : 'rotate-0'
                    }`}
                />
            </button>
        </span>
    );
}

// Button Cancel
export function ButtonCancel({
    children,
    title,
    disabled,
    onClick,
    className = '',
    btnType = 'button'
}) {
    return (
        <button
            type={btnType}
            onClick={onClick}
            className={`bg-primary-100 !text-primary-700 h-10 ${btnCmnStyle} ${className}`}
            disabled={disabled}
        >
            {children || title}
        </button>
    );
}

// Button Pest Fill
export function ButtonPest({
    children,
    title,
    onClick,
    disabled,
    loading = false,
    className = '',
    btnType = '',
    toolTipTitle
}) {
    return (
        <button
            type={btnType || 'button'}
            onClick={onClick}
            className={cn(
                `bg-secondary relative overflow-hidden rounded-lg`,
                btnCmnStyle,
                className
            )}
            disabled={disabled}
            data-tooltip-id="myToolTip"
            data-tooltip-content={toolTipTitle}
        >
            {loading && (
                <span className="inline-block h-full w-full top-0 right-0 absolute bg-secondary">
                    <LoadingAnimateIcon />
                </span>
            )}
            {children || title}
        </button>
    );
}

// Button Pest Line
export function ButtonPestLine({
    children,
    title,
    onClick,
    disabled,
    loading = false,
    className = ''
}) {
    if (loading) {
        return (
            <button
                type="button"
                onClick={null}
                disabled={disabled}
                className={cn(
                    `hover:bg-secondary hover:border-transparent border-secondary text-secondary disabled:pointer-events-none disabled:grayscale disabled:select-none relative`,
                    btnLCmnStyle,
                    className
                )}
            >
                <div className="w-10 h-8 absolute top-1/2 right-[43%] translate-x-1/2 -translate-y-1/2">
                    <LoadingAnimateIcon />
                </div>
                <span style={{ visibility: 'hidden' }}>{title}</span>
            </button>
        );
    }
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                `hover:bg-secondary hover:border-transparent border-secondary text-secondary disabled:pointer-events-none disabled:grayscale disabled:select-none`,
                btnLCmnStyle,
                className
            )}
            disabled={disabled}
        >
            {children || title}
        </button>
    );
}

// Button Edit
export function ButtonEdit({ children, onClick, className = '' }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`w-7 h-7 bg-secondary-100 hover:bg-secondary p-1 rounded text-secondary hover:text-white-100 transition ${className}`}
        >
            {children || <EditIcon />}
        </button>
    );
}

// Button Delete
export function ButtonDelete({ children, onClick, className = '', loading = false }) {
    if (loading) {
        return (
            <button
                type="button"
                onClick={null}
                className={`relative w-7 h-7 bg-error/10 hover:bg-error text-error hover:text-white p-1 rounded transition ${className}`}
            >
                <div className="w-10 h-8 absolute top-1/2 right-[43%] translate-x-1/2 -translate-y-1/2">
                    <LoadingAnimateIcon />
                </div>
                {children || <DeleteIcon />}
            </button>
        );
    }
    return (
        <button
            type="button"
            onClick={onClick}
            className={`w-7 h-7 bg-error/10 hover:bg-error text-error hover:text-white p-1 rounded transition ${className}`}
        >
            {children || <DeleteIcon />}
        </button>
    );
}

function Button({
    children,
    title,
    onClick,
    disabled,
    className,
    type = 'button',
    loading = false
}) {
    if (loading) {
        return (
            <button
                type={type}
                onClick={null}
                className={cn('bg-secondary relative', btnCmnStyle, className)}
                disabled={disabled}
            >
                <div className="w-10 h-8 absolute top-1/2 right-[43%] translate-x-1/2 -translate-y-1/2 disabled:grayscale-[0.5] disabled:pointer-events-none disabled:cursor-default disabled:select-none">
                    <LoadingAnimateIcon />
                </div>
                {children || title}
            </button>
        );
    }
    return (
        <button
            type={type}
            onClick={onClick}
            className={cn('bg-secondary h-10', btnCmnStyle, className)}
        >
            {children || title}
        </button>
    );
}

export default Button;
